export default [
  {
    value: '0.0',
    label: '不限'
  },
  {
    value: '11.0',
    label: 'Android 11.0及以上'
  },
  {
    value: '10.1',
    label: 'Android 10.1及以上'
  },
  {
    value: '10.0',
    label: 'Android 10.0及以上'
  },
  {
    value: '9.0',
    label: 'Android 9.0及以上'
  },
  {
    value: '8.1',
    label: 'Android 8.1及以上'
  },
  {
    value: '8.0',
    label: 'Android 8.0及以上'
  },
  {
    value: '7.1',
    label: 'Android 7.1及以上'
  },
  {
    value: '7.0',
    label: 'Android 7.0及以上'
  },
  {
    value: '6.0',
    label: 'Android 6.0及以上'
  },
  {
    value: '5.1',
    label: 'Android 5.1及以上'
  },
  {
    value: '5.0',
    label: 'Android 5.0及以上'
  },
  {
    value: '4.5',
    label: 'Android 4.5及以上'
  },
  {
    value: '4.4',
    label: 'Android 4.4及以上'
  },
  {
    value: '4.3',
    label: 'Android 4.3及以上'
  },
  {
    value: '4.2',
    label: 'Android 4.2及以上'
  },
  {
    value: '4.1',
    label: 'Android 4.1及以上'
  },
  {
    value: '4.0',
    label: 'Android 4.0及以上'
  },
  {
    value: '3.2',
    label: 'Android 3.2及以上'
  },
  {
    value: '3.1',
    label: 'Android 3.1及以上'
  },
  {
    value: '3.0',
    label: 'Android 3.0及以上'
  },
  {
    value: '2.3',
    label: 'Android 2.3及以上'
  },
  {
    value: '2.2',
    label: 'Android 2.2及以上'
  },
  {
    value: '2.1',
    label: 'Android 2.1及以上'
  },
  {
    value: '2.0',
    label: 'Android 2.0及以上'
  }
]
